<main class="main-page">
  <article class="exercises-list">
    <div class="filters">
      <ft-muscle-multi-select
        [initialTargetMuscles]="(targetMuscles$ | async)!"
        [muscleList]="exerciseDescriptors.muscles"
        (targetMusclesFiltersChanges)="targetMusclesChanges($event)"
      ></ft-muscle-multi-select>

      <mat-form-field appearance="outline">
        <mat-label>Search exercise</mat-label>
        <input
          matInput
          type="text"
          [value]="searchQuery()"
          (input)="onSearchChanges($any($event.target).value)"
          />
      </mat-form-field>

      <mat-button-toggle-group
        name="exerciseOwner"
        aria-label="Exercise by"
        [value]="exerciseOwner()"
        (change)="onExerciseOwnerChanges($event)"
        >
        <mat-button-toggle [value]="ExerciseOwner.FitnessTracker"
          >FitnessTracker</mat-button-toggle
          >
          <mat-button-toggle [value]="ExerciseOwner.User">Mine</mat-button-toggle>
          <mat-button-toggle [value]="ExerciseOwner.All">All</mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      @if (!areExercisesLoading()) {
        <components-exercise-list
          [exerciseList]="filteredExerciseVMs()"
          [selectedForWorkoutIds]="selectedForWorkoutIds.asReadonly()"
          [isWorkoutCreationMode]="isWorkoutCreationMode"
          (exerciseEdited)="navigate(exerciseMode.EDIT, $event)"
          (exerciseViewed)="showExerciseDetails($event)"
          (exerciseDeleted)="deleteExercise($event)"
          (exerciseAddedToWorkout)="addToComposedWorkout($event)"
          (exerciseRemovedFromWorkout)="removeFromComposedWorkout($event)"
        ></components-exercise-list>
      } @else {
        <div class="loader">
          <mat-spinner diameter="100"></mat-spinner>
        </div>
      }

    </article>

    @if (exerciseVMs().length) {
      <mat-accordion class="composed-workout-section">
        <mat-expansion-panel #panel class="mat-app-background" hideToggle disabled>
          <mat-expansion-panel-header>
            <mat-panel-title class="actions">
              @if (!isWorkoutCreationMode) {
                <button
                  mat-stroked-button
                  class="action"
                  color="accent"
                  (click)="isWorkoutCreationMode = true"
                  >
                  Create Workout
                </button>
              }
              @if (isWorkoutCreationMode) {
                <button
                  mat-stroked-button
                  class="action"
                  color="accent"
                  [disabled]="!selectedForWorkoutIds().size"
                  (click)="finishComposing()"
                  >
                  Proceed
                </button>
                <button
                  mat-stroked-button
                  class="action"
                  color="warn"
                  (click)="cancelComposing()"
                  >
                  Cancel
                </button>
              }
            </mat-panel-title>
            @if (selectedForWorkoutIds().size) {
              <button
                mat-icon-button
                aria-label="Selected exercises"
                color="primary"
                (click)="panel.toggle()"
                >
                <mat-icon
                  [matBadge]="selectedForWorkoutIds().size"
                  matBadgeColor="accent"
                  matBadgeSize="small"
                  matBadgeOverlap
                  >search</mat-icon
                  >
                </button>
              }
            </mat-expansion-panel-header>
            <div class="selected-exercises-section">
              @for (exercise of selectedForWorkoutExercises(); track exercise) {
                <mat-card
                  class="selected-exercise mat-elevation-z8"
                  tabindex="0"
                  >
                  <mat-card-title class="card__title">
                    {{ exercise.name }}
                  </mat-card-title>
                  <button
                    mat-icon-button
                    aria-label="Remove exercises"
                    (click)="removeFromComposedWorkout(exercise.id)"
                    >
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-card>
              }
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      }
    </main>
